export var OrderStatus;

(function (OrderStatus) {
  OrderStatus["CLOSED"] = "CLOSED";
  OrderStatus["ERROR"] = "ERROR";
  OrderStatus["REFUNDING"] = "REFUNDING";
  OrderStatus["REFUND"] = "REFUND";
  OrderStatus["SUCCESS"] = "SUCCESS";
  OrderStatus["TO_BE_PAID"] = "TO_BE_PAID";
  OrderStatus["PAID"] = "PAID";
})(OrderStatus || (OrderStatus = {}));

export var OrdersOrderBy = {
  bankType: 'BANK_TYPE',
  className: 'CLASS_NAME',
  createdAt: 'CREATED_AT',
  errCode: 'ERR_CODE',
  errCodeDes: 'ERR_CODE_DES',
  orderNumber: 'ORDER_NUMBER',
  status: 'STATUS',
  timeEnd: 'TIME_END',
  totalPrice: 'TOTAL_AMOUNT',
  tradeType: 'TRADE_TYPE',
  transactionNumber: 'TRANSACTION_NUMBER',
  updatedAt: 'UPDATED_AT',
  year: 'YEAR'
};